import TicketSalesConversionReportChart from "./ui/chart";
import TicketSalesConversionReportTable from "./ui/table";
import { useEffect, useState } from "react";
import { getReportTicketConversion } from "../../../../service/report/ticket";
import { useSelector } from "react-redux";
import { RootState } from "../../../../modules";
import SuperAdminPassword from "../../../../components/SuperAdminPassword";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";

interface IData {
    start: Dayjs | null | undefined,
    end: Dayjs | null | undefined
};
const ReportTicketSalesConversion = () => {
    const [ticketConversionData, setTicketConversionData] = useState<Array<ITicketConversionData>>([]);
    const { isSuperAdmin } = useSelector((state: RootState) => state.superAdmin);
    const [value, setValue] = useState<IData>({ start: dayjs().add(-3, 'month'), end: dayjs() });

    useEffect(() => {
        requestReportTicketConversion()
    }, [value])

    const requestReportTicketConversion = () => {
        if (value && value.start && value.end) {
            getReportTicketConversion({ start: value.start, end: value.end })
                .then((res) => setTicketConversionData(res.data))
                .catch(error => console.error('error', error))
        }
    }

    if (!isSuperAdmin) {
        return <SuperAdminPassword />
    }

    return <>
        <DatePicker.RangePicker value={[value?.start, value?.end]} onChange={(q, w) => setValue({ start: q?.[0], end: q?.[1] })} />
        {ticketConversionData.length > 0 && <>
            <TicketSalesConversionReportChart data={ticketConversionData} />
            <TicketSalesConversionReportTable data={ticketConversionData} />
        </>}
    </>
}

export default ReportTicketSalesConversion;